namespace TabAurous.Purchase {
    export namespace PurchaseSelectItemsService {
        export const baseUrl = 'Purchase/PurchaseSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<PurchaseItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Purchase/PurchaseSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>PurchaseSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
